import { createI18n } from 'vue-i18n'

const messages = {
  fr: {
    greeting: 'Bonjour',

    actions: {
      save: 'Sauvegarder',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      create: 'Créer',
      confirm: 'Confirmer',
      loading: 'Chargement...',
      back: 'Retour'
    },

    common: {
      email: 'Email',
      name: 'Nom',
      phone: 'Téléphone',
      minutes: 'min',
      minutesBefore: 'minutes avant',
      save: 'Sauvegarder',
      saving: 'Sauvegarde...',
      account: 'Compte'
    },

    agent: {
      title: 'Agent',
      name: 'Nom de l’agent',
      description: 'Description',
      language: 'Langue',
      voice: 'Voix',
      status: 'Statut'
    },

    booking: {
      title: 'Prise de rendez-vous',
      titleSettings: 'Configuration',

      subtitle: 'Configuration avancée des rendez-vous',

      enable: 'Activer la prise de rendez-vous',
      enableDesc: 'Permet à l’agent de planifier automatiquement des rendez-vous',

      settings: 'Paramètres généraux',
      timezone: 'Fuseau horaire',
      calendar: 'Calendrier connecté',

      duration: 'Durée du rendez-vous',
      buffer: 'Temps entre les rendez-vous',

      confirmation: 'Mode de confirmation',
      autoConfirm: 'Confirmation automatique',
      autoConfirmDesc: 'Les rendez-vous sont confirmés immédiatement',
      manualConfirm: 'Confirmation manuelle',
      manualConfirmDesc: 'Vous devez approuver chaque rendez-vous',

      availability: 'Disponibilités',

      confirmationNotifications: 'Notifications de confirmation',

      reminders: 'Rappels',

      templates: 'Messages automatiques',
      emailTemplate: 'Template email',
      smsTemplate: 'Template SMS',
      confirmEmailTemplate: 'Email de confirmation',
      confirmSmsTemplate: 'SMS de confirmation',

      collect: 'Informations à collecter',

      ai: 'Comportement de l’agent',

      success: 'Configuration sauvegardée',
        error: 'Erreur lors de la sauvegarde',
        today: "Aujourd’hui",
        thisWeek: "Cette semaine",
        conversion: "Taux de conversion",
        upcoming: "Rendez-vous à venir",

        status: {
            pending: "En attente",
            confirmed: "Confirmé",
            canceled: "Annulé",
            no_show: "Absent"
        },
        testBooking: "Simuler un rendez-vous"
    },

    days: {
      mon: 'Lundi',
      tue: 'Mardi',
      wed: 'Mercredi',
      thu: 'Jeudi',
      fri: 'Vendredi',
      sat: 'Samedi',
      sun: 'Dimanche'
    },

    footer: {
      privacy: 'Confidentialité',
      terms: 'Conditions',
      contact: 'Contact'
    },

    notifications: {
      saved: 'Sauvegarde réussie',
      error: 'Une erreur est survenue',
      missingFields: 'Veuillez remplir tous les champs'
    },

    auth: {
      login: 'Connexion',
      email: 'Email',
      password: 'Mot de passe'
    },

    changeAgent: 'Changer d’agent',
    createAgent: 'Créer un agent',
    changePlan: 'Changer de plan',
    logout: 'Déconnexion',

    menu: {
      dashboard: 'Tableau de bord',
      testLive: 'Test Live',
      'live-monitor': 'Live Monitor',
      liveMonitor: 'Live Monitor',
      booking: 'Rendez-vous',
      templates: 'Modèles',
      agent: 'Agent',
      modules: 'Modules',
      knowledge: 'Base de connaissance',
      personality: 'Personnalité & comportement',
      channels: 'Canaux connectés',
      leads: 'Collecte de leads',
      history: 'Historique',
      workflows: 'Workflows',
      plan: 'Plan & Requêtes',
      settings: 'Paramètres avancés',
      support: 'Support',
      mcp: 'MCP'
    },

    dashboard: {
      title: "Tableau de bord",
      loading: "Chargement des statistiques...",

      agents: "Agents actifs",
      messages: "Messages reçus",
      leads: "Leads collectés",
      requests: "Requêtes restantes",

      leadsPerDay: "Leads par jour",
      messagesPerDay: "Messages par jour",

      conversion: "Taux de conversion",
      todayActivity: "Activité aujourd’hui",

      emailsCollected: "Emails collectés",
      contacts: "Contacts",
      tokensRemaining: "Jetons restants",
      tokensTotal: "Jetons total"
    }
  },

  en: {
    greeting: 'Hello',

    actions: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      confirm: 'Confirm',
      loading: 'Loading...',
      back: 'Back'
    },

    common: {
      email: 'Email',
      name: 'Name',
      phone: 'Phone',
      minutes: 'min',
      minutesBefore: 'minutes before',
      save: 'Save',
      saving: 'Saving...',
      account: 'Account'
    },

    agent: {
      title: 'Agent',
      name: 'Agent name',
      description: 'Description',
      language: 'Language',
      voice: 'Voice',
      status: 'Status'
    },

    booking: {
      title: 'Booking',
      titleSettings: 'Booking settings',
      subtitle: 'Advanced scheduling configuration',

      enable: 'Enable booking',
      enableDesc: 'Allow the AI agent to automatically schedule meetings',

      settings: 'General settings',
      timezone: 'Timezone',
      calendar: 'Connected calendar',

      duration: 'Meeting duration',
      buffer: 'Buffer time between meetings',

      confirmation: 'Confirmation mode',
      autoConfirm: 'Automatic confirmation',
      autoConfirmDesc: 'Appointments are confirmed instantly',
      manualConfirm: 'Manual confirmation',
      manualConfirmDesc: 'You must approve each booking',

      availability: 'Availability',

      confirmationNotifications: 'Confirmation notifications',

      reminders: 'Reminders',

      templates: 'Automated messages',
      emailTemplate: 'Email template',
      smsTemplate: 'SMS template',
      confirmEmailTemplate: 'Confirmation email template',
      confirmSmsTemplate: 'Confirmation SMS template',

      collect: 'Data to collect',

      ai: 'Agent behavior',

      success: 'Configuration saved',
      error: 'Error while saving',
      today: "Today",
      thisWeek: "This week",
      conversion: "Conversion rate",
      upcoming: "Upcoming bookings",
      status: {
          pending: "Pending",
          confirmed: "Confirmed",
          canceled: "Canceled",
          no_show: "No-show"
      },
     testBooking: "Test booking"
    },

    days: {
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday',
      sun: 'Sunday'
    },

    footer: {
      privacy: 'Privacy',
      terms: 'Terms',
      contact: 'Contact'
    },

    notifications: {
      saved: 'Saved successfully',
      error: 'An error occurred',
      missingFields: 'Please fill all fields'
    },

    auth: {
      login: 'Login',
      email: 'Email',
      password: 'Password'
    },

    changeAgent: 'Switch agent',
    createAgent: 'Create agent',
    changePlan: 'Change plan',
    logout: 'Logout',

    menu: {
      dashboard: 'Dashboard',
      testLive: 'Test Live',
      'live-monitor': 'Live Monitor',
      liveMonitor: 'Live Monitor',
      booking: 'Booking',
      templates: 'Templates',
      agent: 'Agent settings',
      modules: 'Modules',
      knowledge: 'Knowledge base',
      personality: 'Personality & behavior',
      channels: 'Connected channels',
      leads: 'Lead collection',
      history: 'Conversation history',
      workflows: 'Workflows',
      plan: 'Plan & Requests',
      settings: 'Advanced settings',
      support: 'Support',
      mcp: 'MCP'
    },

    dashboard: {
      title: "Dashboard",
      loading: "Loading statistics...",

      agents: "Active agents",
      messages: "Messages received",
      leads: "Leads collected",
      requests: "Requests remaining",

      leadsPerDay: "Leads per day",
      messagesPerDay: "Messages per day",

      conversion: "Conversion rate",
      todayActivity: "Today's activity",

      emailsCollected: "Emails collected",
      contacts: "Contacts",
      tokensRemaining: "Tokens remaining",
      tokensTotal: "Total tokens"
    }
  }
}

const savedLang = localStorage.getItem('lang')
const browserLang = (navigator.language || 'en').slice(0, 2)

const locale = savedLang || (['fr', 'en'].includes(browserLang) ? browserLang : 'en')

export default createI18n({
  legacy: true,
  locale,
  fallbackLocale: 'en',
  messages
})
